import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Address} from '../models/address';
import {SessionStorageService} from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService extends BaseApiService {

  constructor(private httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super('enderecos', sessionStorageService);
  }

  async fetchCep(cep: number | string): Promise<Address> {
    return await this.httpClient
      .get<any>(`${this.baseUrl}/${cep}`)
      .pipe(map(item => {
        const address: Address = item.data;

        address.cidade = item.data.municipio;
        
        return address;
      
      }))
      .toPromise();
  }
}
